// @codekit-prepend "map-styles.js"
// @codekit-prepend "marker.js"
// @codekit-prepend "marker-cluster.js"
// @codekit-prepend "tour-marker.js"
// @codekit-prepend "user-marker.js"

$.Event('mapsLoaded');

window.WeleerMap = {
    init: function (callback) {
        WeleerMap.initialized = true;
        WeleerMap.markers = [];
        WeleerMap.selectedMarkers = [];
        WeleerMap.markerIndex = {};
        WeleerMap.clusterIndex = {};
        WeleerMap.onReady = callback;
        WeleerMap.zoomControl = $('.zoom-control');

        WeleerMap.mapDiv = $('#map');
        let center = WeleerMap.mapDiv.data('center');
        let viewport = WeleerMap.mapDiv.data('viewport');
        let markersSrc = WeleerMap.mapDiv.data('markers-src');

        if (WeleerMap.zoomControl.length > 0) {
            WeleerMap.zoomInButton = WeleerMap.zoomControl.find('.zoom-in');
            WeleerMap.zoomOutButton = WeleerMap.zoomControl.find('.zoom-out');
            WeleerMap.zoomInButton.on('click', WeleerMap.mapZoomIn);
            WeleerMap.zoomOutButton.on('click', WeleerMap.mapZoomOut);
        }

        WeleerMap.minZoom = 15;
        WeleerMap.maxZoom = 19;
        WeleerMap.map = new google.maps.Map(document.getElementById('map-canvas'), {
            center: {lat: center.lat, lng: center.lon},
            disableDefaultUI: true,
            clickableIcons: false,
            gestureHandling: 'greedy',
            styles: mapStyles
        });
        WeleerMap.map.fitBounds(viewport, 0);

        google.maps.event.addListenerOnce(WeleerMap.map, 'idle', function() {
            WeleerMap.map.setZoom(WeleerMap.map.getZoom() + 1);
            WeleerMap.onUserChangeBounds();
        });
        WeleerMap.map.addListener('dragend', WeleerMap.onUserChangeBounds);
        WeleerMap.map.addListener('zoom_changed', WeleerMap.updateZoomControl);

        $(document).trigger('mapsLoaded');
        $(document).on('polygonChanged', WeleerMap.onPolygonChange);

        $.ajax({
            url: markersSrc,
            type: 'POST',
            data: { token: $.csrfToken },
            dataType: 'json',
            success: WeleerMap.markersFetched,
            error: WeleerMap.markersError
        });
    },
    markerPicture: function (item) {
        let src = '/images/photo/image/map/' + item.basename + '.' + item.extension;
        let retina = '/images/photo/image/map/' + item.basename + '@2x.' + item.extension;
        let srcLarge = '/images/photo/image/map-large/' + item.basename + '.' + item.extension;
        let retinaLarge = '/images/photo/image/map-large/' + item.basename + '@2x.' + item.extension;
        return '<picture style="background:#' + item.color + '">' +
            '<source media="(min-width:75rem)" srcset="' + srcLarge + ' 1x, ' + retinaLarge + ' 2x"/>' +
            '<source media="(min-height:62.5rem)" srcset="' + srcLarge + ' 1x, ' + retinaLarge + ' 2x"/>' +
            '<source srcset="' + src + ' 1x, ' + retina + ' 2x"/>' +
            '<img src="' + src + '"/></picture>';
    },
    markersFetched: function (data) {
        for (let item of data) {
            if (item.id) {
                var marker = new Marker({
                    position: {lat: item.lat, lng: item.lon},
                    picture: WeleerMap.markerPicture(item),
                    title: item.title,
                    url: item.url,
                    angle: item.angle,
                    yearMin: item.year_min,
                    yearMax: item.year_max,
                    id: item.id,
                    accuracy: item.accuracy,
                    type: item.type,
                    publication: item.publication,
                    comparable: item.comparable
                });
                marker.setMap(WeleerMap.map);
                WeleerMap.markers.push(marker);
                WeleerMap.markerIndex[item.id] = marker;
            } else {
                let cluster = new MarkerCluster({
                    position: {lat: item.lat, lng: item.lon},
                    title: item.title,
                    url: item.url,
                    slug: item.slug
                });
                for (let subitem of item.photos) {
                    let marker = new Marker({
                        position: {lat: subitem.lat, lng: subitem.lon},
                        picture: WeleerMap.markerPicture(subitem),
                        title: subitem.title,
                        url: subitem.url,
                        angle: subitem.angle,
                        yearMin: subitem.year_min,
                        yearMax: subitem.year_max,
                        id: subitem.id,
                        accuracy: subitem.accuracy,
                        type: subitem.type,
                        publication: subitem.publication,
                        comparable: subitem.comparable
                    });
                    cluster.push(marker);
                    WeleerMap.markerIndex[subitem.id] = marker;
                }
                cluster.setMap(WeleerMap.map);
                WeleerMap.markers.push(cluster);
                WeleerMap.clusterIndex[item.slug] = cluster;
            }
        }
        let map = $('#map');
        if (map.data('cluster')) WeleerMap.selectCluster(map.data('cluster'));
        if (map.data('marker')) WeleerMap.selectMarker(map.data('marker'));
        if (map.data('markers')) WeleerMap.selectMarkers(map.data('markers'));
        if (Navigation.current().tour) WeleerMap.setTour(Navigation.current().tour);
        if (Navigation.current().tour_index) Navigation.setTourWaypoint(Navigation.current().tour_index);
        if (WeleerMap.onReady) WeleerMap.onReady(true);
    },
    markersError: function () {
        if (WeleerMap.onReady) WeleerMap.onReady(false);
    },
    filterMarkers: function (yearMin, yearMax, types, highlightTime, onlyComparable) {
        const markers = WeleerMap.selectedMarkers.length > 0 ? WeleerMap.selectedMarkers : WeleerMap.markers;
        for (let marker of markers) {
            marker.filter(yearMin, yearMax, types, highlightTime, onlyComparable);
        }
    },
    selectMarker: function (id) {
        if (id) {
            id = parseInt(id, 10);
            if (WeleerMap.markerIndex[id]) {
                if (!WeleerMap.selectedMarkers && !MarkerCluster.activeCluster && WeleerMap.markerIndex[id].cluster) WeleerMap.markerIndex[id].cluster.activate();
                else if (WeleerMap.selectedMarkers && $.inArray(WeleerMap.markerIndex[id], WeleerMap.selectedMarkers) < 0 && WeleerMap.markerIndex[id].cluster) WeleerMap.markerIndex[id].cluster.activate();
                if (WeleerMap.map.getBounds() && !WeleerMap.map.getBounds().contains(WeleerMap.markerIndex[id].getPosition())) {
                    WeleerMap.map.panTo(WeleerMap.markerIndex[id].getPosition());
                }
                WeleerMap.markerIndex[id].activate();
            }
        } else {
            if (Marker.activeMarker) Marker.activeMarker.deactivate();
        }
    },
    selectCluster: function (slug) {
        if (slug == 1) {
            if (MarkerCluster.activeCluster) MarkerCluster.reset();
        } else if (slug) {
            if (WeleerMap.clusterIndex[slug]) WeleerMap.clusterIndex[slug].activate();
        }
    },
    selectMarkers: function (markers) {
        if (!markers) return WeleerMap.deselectMarkers();
        
        if (MarkerCluster.activeCluster && MarkerCluster.activeCluster.markers != markers) MarkerCluster.activeCluster.deactivate();
        
        const currentMarkers = WeleerMap.selectedMarkers;
        WeleerMap.selectedMarkers = [];

        let markerBounds = new google.maps.LatLngBounds();
        let ids = [];
        for (let id of markers) {
            id = parseInt(id, 10);
            const marker = WeleerMap.markerIndex[parseInt(id, 10)];
            if (marker) {
                ids.push(id);
                WeleerMap.selectedMarkers.push(marker);
                markerBounds.extend(marker.options.position);
            }
        }
        WeleerMap.recluster(currentMarkers.filter(marker => ids.indexOf(marker.options.id) < 0));
        if (!WeleerMap.selectedMarkers.length) return;
        WeleerMap.decluster(WeleerMap.selectedMarkers);
        for (let marker of WeleerMap.markers) {
            if (!marker.options.id || ids.indexOf(marker.options.id) < 0) marker.setFiltered(true);
        }
        WeleerMap.map.fitBounds(markerBounds);
        Application.filterPhotos();
    },
    deselectMarkers: function () {
        if (WeleerMap.selectedMarkers.length === 0) return;
        WeleerMap.recluster(WeleerMap.selectedMarkers);
        WeleerMap.selectedMarkers = [];
        Application.filterPhotos();
    },
    decluster: function (markers) {
        markers = markers.filter(marker => !!marker.cluster);
        for (let marker of markers) {
            if (marker.declusterTimer) clearTimeout(marker.declusterTimer);
            if (marker.getMap()) {
                marker.div.removeClass('appearing');
                continue;
            }
            marker.setMap(WeleerMap.map);
            marker.div.removeClass('disappearing').addClass('appearing');
            marker.declusterTimer = setTimeout(function(){
                marker.div.removeClass('appearing');
            }, 50);
        }
    },
    recluster: function (markers) {
        markers = markers.filter(marker => !!marker.cluster);
        for (let marker of markers) {
            if (marker.declusterTimer) clearTimeout(marker.declusterTimer);
            marker.div.addClass('appearing');
            marker.declusterTimer = setTimeout(function(){
                marker.div.removeClass('appearing');
                marker.setMap(null);
                marker.div.remove();
            }, 500);
        }
    },
    hoverMarker: function (id) {
        if (Marker.hoverMarker) Marker.hoverMarker.hover(false);
        if (id) {
            id = parseInt(id, 10);
            if (WeleerMap.markerIndex[id]) WeleerMap.markerIndex[id].hover();
        }
    },
    unHoverMarker: function (id) {
        if (id) {
            id = parseInt(id, 10);
            if (WeleerMap.markerIndex[id]) WeleerMap.markerIndex[id].hover(false);
        }
    },
    mapZoomIn: function () {
        if (WeleerMap.map.getZoom() <= WeleerMap.maxZoom) {
            WeleerMap.map.setZoom(WeleerMap.map.getZoom() + 1);
            WeleerMap.onUserChangeBounds();
        }
    },
    mapZoomOut: function () {
        if (WeleerMap.map.getZoom() >= WeleerMap.minZoom) {
            WeleerMap.map.setZoom(WeleerMap.map.getZoom() - 1);
            WeleerMap.onUserChangeBounds();
        }
    },
    updateZoomControl: function () {
        WeleerMap.zoomOutButton.toggleClass('disabled', WeleerMap.map.getZoom() < WeleerMap.minZoom);
        WeleerMap.zoomInButton.toggleClass('disabled', WeleerMap.map.getZoom() > WeleerMap.maxZoom);
    },
    reset: function () {
        if (Marker.activeMarker) Marker.activeMarker.deactivate();
        if (MarkerCluster.activeCluster) MarkerCluster.reset();
        if (WeleerMap.selectedMarkers) WeleerMap.deselectMarkers();
        WeleerMap.resetBounds();
    },
    resetBounds: function () {
        if (WeleerMap.lastBounds) {
            WeleerMap.map.panTo(WeleerMap.lastBounds.center);
            WeleerMap.map.setZoom(WeleerMap.lastBounds.zoom);
        }
    },
    onUserChangeBounds: function () {
        WeleerMap.lastBounds =  {
            center: WeleerMap.map.getCenter(),
            zoom: WeleerMap.map.getZoom()
        };
    },
    onPolygonChange: function (event, polygon) {
        if (WeleerMap.activePolygon) WeleerMap.activePolygon.setMap(null);
        if (polygon) {
            WeleerMap.activePolygon = new google.maps.Polygon({
                paths: polygon,
                strokeColor: '#151413',
                strokeWeight: 2,
                strokeOpacity: 1,
                fillColor: '#F9D158',
                fillOpacity: 0.25
            });
            WeleerMap.activePolygon.setMap(WeleerMap.map);
        }
    },
    setTour: function (tour) {
        if (WeleerMap.activeTour && (!tour || tour.id !== WeleerMap.activeTour.id)) {
            Navigation.setTourWaypoint(0)
            if (WeleerMap.tourMarkers) {
                for (var i = 0; i < WeleerMap.tourMarkers.length; i++) {
                    WeleerMap.tourMarkers[i].setMap(null);
                }
            }
            WeleerMap.mapPolylineShadow.setMap(null);
            WeleerMap.tourMarkers = []
            WeleerMap.activeTour = null
        }
        if (tour && !WeleerMap.activeTour) {
            WeleerMap.tourMarkers = []
            let points = [];
            let bounds = new google.maps.LatLngBounds()
            for (var i = 0; i < tour.waypoints.length; i++) {
                if (tour.waypoints[i].polyline) {
                    for (var j = (points.length > 0 ? 1 : 0); j < tour.waypoints[i].polyline.length; j++) {
                        points.push(tour.waypoints[i].polyline[j]);
                    }
                }
                let marker = new TourMarker({
                    position: {lat: tour.waypoints[i].coordinates.lat, lng: tour.waypoints[i].coordinates.lon},
                    url: tour.waypoints[i].url,
                    id: tour.waypoints[i].id,
                    index: tour.waypoints[i].index
                });
                marker.setMap(WeleerMap.map);
                bounds.extend(marker.getPosition());
                WeleerMap.tourMarkers.push(marker)
            }
            WeleerMap.mapPolylineShadow = new google.maps.Polyline({
                path: points,
                strokeColor: '#302D2B',
                strokeOpacity: 1.0,
                strokeWeight: 5
            });
            WeleerMap.mapPolylineShadow.setMap(WeleerMap.map);
            WeleerMap.map.fitBounds(bounds)
            WeleerMap.activeTour = tour

            $('#tour-controls h1').text(tour.name)
        }
        if (WeleerMap.mapDiv) {
            WeleerMap.mapDiv.toggleClass('touring', !!WeleerMap.activeTour)
            if (WeleerMap.activeTour) $('body').addClass('mobile-map');
        }
    },
    setTourWaypoint: function (index) {
        if (index == WeleerMap.activeTourIndex) return;
        if (WeleerMap.activeTourIndex && WeleerMap.tourMarkers[WeleerMap.activeTourIndex - 1]) {
            WeleerMap.tourMarkers[WeleerMap.activeTourIndex - 1].div.removeClass('active')
        }
        WeleerMap.activeTourIndex = index;

        if (WeleerMap.mapPolyline) {
            WeleerMap.mapPolyline.setMap(null)
            WeleerMap.mapPolyline = null
        }

        if (index > 0) {
            WeleerMap.tourMarkers[index - 1].div.addClass('active');
            $('body').addClass('mobile-map');
            $('#content').addClass('touring');
            $('#search').attr('aria-hidden', 'true');
            $('#tour-controls').addClass('appeared').removeAttr('aria-hidden');

            if (navigator.geolocation && !WeleerMap.userMarker) {
                navigator.geolocation.getCurrentPosition( position => {
                    WeleerMap.userMarker = new UserMarker({
                        position: { lat: position.coords.latitude, lng: position.coords.longitude }
                    })
                    WeleerMap.userMarker.setMap(WeleerMap.map)
                });
            }

            const waypoint = WeleerMap.activeTour.waypoints[index - 1];
            const polyline = waypoint.polyline;
            if (polyline && polyline.length > 1) {
                WeleerMap.mapPolyline = new google.maps.Polyline({
                    path: polyline,
                    strokeColor: '#F9D158',
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                    zIndex: 10
                });
                WeleerMap.mapPolyline.setMap(WeleerMap.map);
            }

            if (index == 1) {
                WeleerMap.map.panTo({lat: waypoint.coordinates.lat, lng: waypoint.coordinates.lon})
                WeleerMap.map.setZoom(17)
            } else {
                let bounds = new google.maps.LatLngBounds();
                const prevWaypoint = WeleerMap.activeTour.waypoints[index - 2];
                bounds.extend({lat: waypoint.coordinates.lat, lng: waypoint.coordinates.lon})
                bounds.extend({lat: prevWaypoint.coordinates.lat, lng: prevWaypoint.coordinates.lon})
                WeleerMap.map.fitBounds(bounds)
            }
        } else {
            $('#content').removeClass('touring');
            $('#search').removeAttr('aria-hidden');
            $('#tour-controls').attr('aria-hidden', 'true');

            if (WeleerMap.userMarker) {
                WeleerMap.userMarker.destroy()
                WeleerMap.userMarker = null
            }
        }
    }
}
